import EventBus from '../EventBus'

export default {
    methods: {
        confirmDialog: function (text, onYes, onNo = () => { this.snackbar("Action Cancelled") }) {
            EventBus.$emit('ConfirmDialogOpen', { text: text, onYes: onYes, onNo: onNo })
        },
    }
}